import React from "react";
import {useSelector} from "react-redux";
import {useLocation, useRouteMatch} from "react-router";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {Pagination} from "@pg-design/pagination-module";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../app/rp_reducer";
import {useResponsiveLinkTarget} from "../../hooks/useResponsiveLinkTarget";
import {createOfferLink} from "../../offer/helpers/create_offer_link";
import {ISitemapRegionListRegion} from "../actions/fetch_site_map_region";
import {SiteMapBoxList} from "../components/SiteMapBoxList";
import {SiteMapHeading} from "../components/SiteMapHeading";

export const SiteMapOffersVoivodeship = () => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const {voivodeshipSlug} = useRouteMatch<{voivodeshipSlug: string}>().params;
    const location = useLocation();
    const offers = useSelector((state: IRPStore) => state.siteMap.offers);
    const voivodeship = useSelector((state: IRPStore) => state.siteMap.regions.voivodeship)?.find((v) => v.slug === voivodeshipSlug);
    const voivodeshipNameDeclensionWhere = (voivodeship as ISitemapRegionListRegion)?.name_declension_where;

    const parsedSearch = parseSearch(location.search);
    const getPageLink = (page: number) => {
        const query = validateQuery(["page"], parsedSearch, page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(location.pathname, query);
    };
    const currentPage = parseInt(parsedSearch.page as string, 10) || 1;
    const pageSuffix = currentPage > 1 ? ` (strona ${currentPage})` : "";

    const records = offers?.results.map((offer) => ({
        href: createOfferLink(offer),
        header: offer.name,
        text: offer.vendor.name
    }));

    return (
        <Container css={[mb(4)]}>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                <BreadcrumbsItem name="Mapa strony" position="2" url={rpAppLink.siteMap.base()} />
                <BreadcrumbsItem name="Inwestycje" position="3" url={rpAppLink.siteMap.offer.base()} />
                {voivodeship?.name && (
                    <BreadcrumbsItem
                        isLinkingToCurrentLocation
                        name={voivodeship.name}
                        position="4"
                        url={rpAppLink.siteMap.offer.voivodeship({voivodeshipSlug: voivodeship.slug})}
                    />
                )}
            </Breadcrumbs>

            <article>
                <SiteMapHeading>
                    Inwestycje deweloperskie {voivodeshipNameDeclensionWhere}
                    {pageSuffix}
                </SiteMapHeading>

                <SiteMapBoxList records={records ?? []} css={[mb(4)]} target={responsiveLinkTarget} />

                <Pagination
                    pageCount={Math.ceil((offers?.count ?? 0) / (offers?.page_size ?? 1))}
                    currentPage={currentPage}
                    getPageLink={getPageLink}
                    css={[mb(4)]}
                />
            </article>
        </Container>
    );
};
import React from "react";
import {useSelector} from "react-redux";
import {useLocation, useRouteMatch} from "react-router";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {Pagination} from "@pg-design/pagination-module";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../app/rp_reducer";
import {useResponsiveLinkTarget} from "../../hooks/useResponsiveLinkTarget";
import {createOfferLink} from "../../offer/helpers/create_offer_link";
import {ISitemapRegionListRegion} from "../actions/fetch_site_map_region";
import {SiteMapBoxList} from "../components/SiteMapBoxList";
import {SiteMapHeading} from "../components/SiteMapHeading";

export const SiteMapOffersVoivodeship = () => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const {voivodeshipSlug} = useRouteMatch<{voivodeshipSlug: string}>().params;
    const location = useLocation();
    const offers = useSelector((state: IRPStore) => state.siteMap.offers);
    const voivodeship = useSelector((state: IRPStore) => state.siteMap.regions.voivodeship)?.find((v) => v.slug === voivodeshipSlug);
    const voivodeshipNameDeclensionWhere = (voivodeship as ISitemapRegionListRegion)?.name_declension_where;

    const parsedSearch = parseSearch(location.search);
    const getPageLink = (page: number) => {
        const query = validateQuery(["page"], parsedSearch, page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(location.pathname, query);
    };
    const currentPage = parseInt(parsedSearch.page as string, 10) || 1;
    const pageSuffix = currentPage > 1 ? ` (strona ${currentPage})` : "";

    const records = offers?.results.map((offer) => ({
        href: createOfferLink(offer),
        header: offer.name,
        text: offer.vendor.name
    }));

    return (
        <Container css={[mb(4)]}>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                <BreadcrumbsItem name="Mapa strony" position="2" url={rpAppLink.siteMap.base()} />
                <BreadcrumbsItem name="Inwestycje" position="3" url={rpAppLink.siteMap.offer.base()} />
                {voivodeship?.name && (
                    <BreadcrumbsItem
                        isLinkingToCurrentLocation
                        name={voivodeship.name}
                        position="4"
                        url={rpAppLink.siteMap.offer.voivodeship({voivodeshipSlug: voivodeship.slug})}
                    />
                )}
            </Breadcrumbs>

            <article>
                <SiteMapHeading>
                    Inwestycje deweloperskie {voivodeshipNameDeclensionWhere}
                    {pageSuffix}
                </SiteMapHeading>

                <SiteMapBoxList records={records ?? []} css={[mb(4)]} target={responsiveLinkTarget} />

                <Pagination
                    pageCount={Math.ceil((offers?.count ?? 0) / (offers?.page_size ?? 1))}
                    currentPage={currentPage}
                    getPageLink={getPageLink}
                    css={[mb(4)]}
                />
            </article>
        </Container>
    );
};
